import React from 'react';

import {
  Colors,
} from '@noitada/shared/constants';

import {
  Epigraph,
} from '../../Composh/web';

import {
  MenuEpigraphSection,
} from './styled';



export interface IProps {
  title: string;
  color?: string;
}



const DrawerTitle: React.FC<IProps> = (props: IProps) => {
  const colorTitle = props.color || Colors.primary;


  return (

    <MenuEpigraphSection>

      <Epigraph.Section
        text={props.title}
        textColor={colorTitle}
        borderBottomColor={colorTitle}
      />

    </MenuEpigraphSection>

  );
};



export default DrawerTitle;
